import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import AuthContextProvider from './context/AuthContext';
import CssBaseline from '@material-ui/core/CssBaseline';
import ErrorBoundary from './UI/Errors/ErrorBoundary';
import { ThemeProvider } from 'styled-components';
import { theme } from './theme/index';
import AppContextProvider from 'context/AppContext';
import AlertContextProvider from 'context/AlertContext';
import AppLayout from 'components/AppLayout';
import { QueryClient, QueryClientProvider } from 'react-query';
import { getSessionVal, setSessionStorage } from 'utils/CommonFunc';

const queryClient = new QueryClient();
function App() {


  const urlParams = new URLSearchParams(window.location.search);
  const authTokenParam = urlParams.get('Token');

  const [token, setToken] = useState(null);
  const [flagTokenPre, setFlagTokenPre] = useState(false);
  const isInitialRender = useRef(true);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
    } else {
      setToken(getSessionVal('authToken'));
      // Place the code you want to run on value change here
    }
  }, [flagTokenPre]);

  useEffect(() => {
    let refferedToken = getSessionVal('authToken');
    if (refferedToken) {
      if (!authTokenParam && refferedToken) {
        setSessionStorage('authToken', refferedToken);
        setFlagTokenPre(true);
      } else if (authTokenParam && refferedToken) {
        if (refferedToken !== authTokenParam) {
          setSessionStorage('authToken', authTokenParam);
          setFlagTokenPre(true);
        }
      }
    } else {
      setSessionStorage('authToken', authTokenParam);
      setFlagTokenPre(true);
    }
  }, [authTokenParam]);

  const location = useLocation();

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <style>
            {location.pathname === '/login'
              ? `body { background: linear-gradient(224deg,
                ${theme?.colors?.primary?.default || '#0042b0'}, 0%, ${
                  theme?.colors?.primary?.dark || '#002c75'
                } 100%); position:relative; display: flex; justify-content: center; overflow:auto;}`
              : ``}
          </style>
          <CssBaseline />
          <AuthContextProvider authToken={token || authTokenParam}>
            <AppContextProvider>
              <AlertContextProvider>
                <AppLayout token={token} />
              </AlertContextProvider>
            </AppContextProvider>
          </AuthContextProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default Sentry.withProfiler(App);
